import React, {ReactNode} from 'react';

const KeyboardView: React.FC<{children: ReactNode}> = ({children}) => {
  return <>{children}</>;
};

export default React.memo(KeyboardView);
